import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../services/auth.service';
import { FrontendPermissionDTO } from '../model/auth/frontend-permission-dto';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent implements OnInit {
  permissions: FrontendPermissionDTO[] = [];
  currentUser = '';

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadPermissions();
    this.getCurrentUser();
  }

  loadPermissions(): void {
    const storedPermissions = this.authService.getStoredPermissions();
    if (storedPermissions) {
      this.permissions = storedPermissions;
    } else {
      // Si no hay permisos guardados, obtenerlos del servidor
      this.authService.getFrontendPermissions().subscribe({
        next: (response) => {
          if (response.statusCode === '000' && response.data) {
            this.permissions = response.data;
          }
        },
        error: (err) => {
          console.error('Error cargando permisos:', err);
        }
      });
    }
  }

  getCurrentUser(): void {
    const token = this.authService.getAccessToken();
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        this.currentUser = payload.email || 'Usuario';
      } catch (error) {
        this.currentUser = 'Usuario';
      }
    }
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        // El servicio ya redirige al login
      },
      error: (err) => {
        console.error('Error al cerrar sesión:', err);
        // Forzar limpieza y redirección en caso de error
        this.authService.clearTokens();
        this.router.navigate(['/admin/login']);
      }
    });
  }

  canAccess(path: string): boolean {
    return this.authService.canAccessRoute(path);
  }
}
